import {useAppDispatch, useAppSelector} from './useReduxHooks'
import * as actions from '../redux/reducers/subjects/service'
import {
  ActivateSubjectRequest,
  CreateSubjectRequest,
  DeleteSubjectRequest,
  FetchAllSubjectsRequest,
  FetchSubjectByIdRequest,
  FetchSubjectsRequest,
  SuspendSubjectRequest,
  UpdateSubjectRequest,
} from '../redux/reducers/subjects/types'

export default function useSubjects() {
  const dispatch = useAppDispatch()
  const {subjects, subjectForEdit, listLoading, actionLoading, error, total, totalPages} =
    useAppSelector((state) => state.subjects)

  const fetchSubjects = (props: FetchSubjectsRequest) => {
    return dispatch(actions.fetchSubjects(props))
  }

  const fetchAllSubjects = (props: FetchAllSubjectsRequest) => {
    return dispatch(actions.fetchAllSubjects(props))
  }

  const fetchSubjectById = (props: FetchSubjectByIdRequest) => {
    return dispatch(actions.fetchSubjectById(props))
  }

  const createSubject = (props: CreateSubjectRequest) => {
    return dispatch(actions.createSubject(props))
  }

  const updateSubject = (props: UpdateSubjectRequest) => {
    return dispatch(actions.updateSubject(props))
  }

  const deleteSubject = (props: DeleteSubjectRequest) => {
    return dispatch(actions.deleteSubject(props))
  }

  const suspendSubject = (props: SuspendSubjectRequest) => {
    return dispatch(actions.suspendSubject(props))
  }

  const activateSubject = (props: ActivateSubjectRequest) => {
    return dispatch(actions.activateSubject(props))
  }

  return {
    fetchAllSubjects,
    subjectForEdit,
    subjects,
    listLoading,
    actionLoading,
    error,
    fetchSubjects,
    fetchSubjectById,
    createSubject,
    updateSubject,
    deleteSubject,
    suspendSubject,
    activateSubject,
    total,
    totalPages,
  }
}
